import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../lib/auth.js';

interface OwnerOnlyProps {
  children: ReactNode;
}

/**
 * Client-side route gate for owner-only paths (T-168/T-169): margin/profitability
 * surfaces an admin must not see. Redirects to / for a non-owner. As with
 * AdminOnly, the server (requireOwner) is the real boundary; this is UX only.
 */
export function OwnerOnly({ children }: OwnerOnlyProps) {
  const { admin } = useAuth();
  if (!admin) return null;
  if (!admin.is_owner) return <Navigate to="/" replace />;
  return <>{children}</>;
}
